import * as React from "react";
import PropTypes from "prop-types";
const SvgActionsArrowLeftNormalXsmall = React.forwardRef(
  ({ color = "currentColor", size = 16, title, titleId, ...props }, ref) => (
    <svg
      fill={color}
      viewBox="0 0 16 16"
      xmlns="http://www.w3.org/2000/svg"
      ref={ref}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        d="M10.5 14.384L4.912 8.796a1.125 1.125 0 010-1.591L10.5 1.616l.884.884-5.5 5.5 5.5 5.5z"
        fill=""
      />
    </svg>
  )
);
SvgActionsArrowLeftNormalXsmall.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  title: PropTypes.string,
  titleId: PropTypes.string,
};
export default SvgActionsArrowLeftNormalXsmall;
